// extracted by mini-css-extract-plugin
export default {"table-grid":"sites-table_table-grid__93IC2"};